module.exports = __webpack_public_path__ + "img/5.6e9df2b3.jpg";